const _Storage = class Storage {
    /**
     * 存储localStorage
     */
    set(name, content) {
        if (!name) {
            return;
        }
        // console.log('key', this.key)
        if (typeof content !== 'string') {
            content = JSON.stringify(content);
        }
        window.localStorage.setItem(name, content);
    }
    /**
     * 获取localStorage
     */
    get(name) {
        if (!name) {
            return;
        }
        return window.localStorage.getItem(name);
    }
    /**
     * 删除localStorage
     */
    remove(name) {
        if (!name) {
            return;
        }
        window.localStorage.removeItem(name);
    }
    /**
     * 清空clearStorage
     */
    clear(name) {
        if (!name) {
            return;
        }
        window.localStorage.clear();
    }
};
export default new _Storage();
